import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

interface PackageIntegrationTogglesProps {
  value: string[];
  onChange: (next: string[]) => void;
}

const integrations = [
  { code: 'integration.telegram', label: 'Telegram' },
  { code: 'integration.discord', label: 'Discord' },
  { code: 'integration.email', label: 'Email' },
];

export const PackageIntegrationToggles: React.FC<PackageIntegrationTogglesProps> = ({
  value,
  onChange,
}) => {
  const toggleIntegrationEntitlement = (code: string, enabled: boolean) => {
    const current = new Set(value || []);
    if (enabled) {
      current.add(code);
    } else {
      current.delete(code);
    }

    onChange([...current]);
  };

  return (
    <Box>
      <Typography
        variant="subtitle1"
        className="mb-2 font-semibold text-gray-700 dark:text-slate-300"
      >
        Integrations
      </Typography>
      <Box className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {integrations.map((item) => {
          const enabled = value?.includes(item.code) ?? false;

          return (
            <Box
              key={item.code}
              className="rounded-lg border border-slate-200 p-3 dark:border-slate-700"
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={enabled}
                    onChange={(event) =>
                      toggleIntegrationEntitlement(item.code, event.target.checked)
                    }
                    color="primary"
                  />
                }
                label={item.label}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
